import moment from 'moment';

import { interpretMessage } from '../../utils/interpret-message/interpretMessage';
import { CustomMessageOptions } from '../type';

const MESSAGE = 'Must be a valid date {{example}}';

export function createValidDateValidator(
    // this is to support mixed of month or day padded vs unpadded formats
    format = [ 'M/D/YYYY', 'M/DD/YYYY', 'MM/D/YYYY', 'MM/DD/YYYY' ],
    msgOptions?: CustomMessageOptions & { example?: string },
): (val: string) => boolean | string {
    return (val: string): boolean | string => {
        // if there is no value we should consider it valid as it should be part of required validator
        if (!val || val === '') {
            return true;
        }
        const momentVal = moment(val, format, true);
        if (momentVal.isValid()) {
            return true;
        }
        const message = msgOptions?.customMsg || MESSAGE;
        const example = `(e.g. ${moment('2025-01-01').format(format[0])})`;
        return interpretMessage(
            message,
            {
                field: msgOptions?.fieldName || 'field',
                example: msgOptions?.example || example,
            },
        );
    };
}
